<template>
    <div class="subTitleBox" v-if="subtitle.trainImage">
        <img :src="subtitle.trainImage" :alt="subtitle.title" :title="subtitle.title">
        <span>{{subtitle.title}}</span>
    </div>
</template>

<script>
export default {
    props: {
        subtitle: Object
    },
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
};
</script>

<style scoped >

</style>